import { render, staticRenderFns } from "./LegoChatBox.vue?vue&type=template&id=b65d699c&scoped=true"
import script from "./LegoChatBox.vue?vue&type=script&lang=js"
export * from "./LegoChatBox.vue?vue&type=script&lang=js"
import style0 from "./LegoChatBox.vue?vue&type=style&index=0&id=b65d699c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65d699c",
  null
  
)

export default component.exports